import { WindowRefService } from './window-ref.service';
var WhatsappService = /** @class */ (function () {
    function WhatsappService(windowRef) {
        this.windowRef = windowRef;
        this.hostWhatsappDesktop = 'https://web.whatsapp.com/send?phone=';
        this.hostWhatsappMobile = 'https://wa.me/';
        this.countryCode = '54';
    }
    WhatsappService.prototype.sendWhatsapp = function (isMobile, phoneNumber, message) {
        message = message || '';
        this.link = '';
        var options = 'toolbar=yes,scrollbars=yes,resizable=yes,top=500,left=500,width=800,height=500';
        var countryCode = (isMobile) ? this.countryCode : "+" + this.countryCode;
        var phone = "" + countryCode + phoneNumber;
        this.link = (isMobile) ? "" + this.hostWhatsappMobile + phone + "?text=" + message
            : "" + this.hostWhatsappDesktop + phone + "&text=" + message;
        this.windowRef.nativeWindow.open(this.link, '_blank', options);
    };
    return WhatsappService;
}());
export { WhatsappService };
